import { gql } from '@apollo/client'

export default gql`
  mutation ChangeGuild($id: String!, $type: GuildType!) {
    joinAsGuildMemberByType(guildType: $type, guildID: $id)
  }
`
